/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Load_ConfirmInputs */

const en_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load`)
};

const fr_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger`)
};

const de_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden`)
};

const it_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carico`)
};

const ru_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нагрузка`)
};

const es_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

const zh_cn2_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载`)
};

const ja_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`負荷`)
};

const hi_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भार`)
};

const pt_pt2_subtitle_export_preset_load_confirm = /** @type {(inputs: Subtitle_Export_Preset_Load_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar`)
};

/**
* | output |
* | --- |
* | "Load" |
*
* @param {Subtitle_Export_Preset_Load_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_load_confirm = /** @type {((inputs?: Subtitle_Export_Preset_Load_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Load_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_load_confirm(inputs)
	if (locale === "de") return de_subtitle_export_preset_load_confirm(inputs)
	if (locale === "it") return it_subtitle_export_preset_load_confirm(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_load_confirm(inputs)
	if (locale === "es") return es_subtitle_export_preset_load_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_load_confirm(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_load_confirm(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_load_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_load_confirm(inputs)
	return en_subtitle_export_preset_load_confirm(inputs)
});